import type { ApiError } from "@circle-react/config/CustomErrors";
import { reactQueryDelete } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";

interface DestroyPlanTrialResponse {
  error_details?: string[];
  success: boolean;
}

export const useDestroyPlanTrial = (
  options?: UseMutationOptions<DestroyPlanTrialResponse, ApiError, void>,
) => {
  const destroyPlanTrial = async () =>
    reactQueryDelete<DestroyPlanTrialResponse, Record<string, never>>(
      internalApi.planTrials.destroy(),
    );

  return useMutation<DestroyPlanTrialResponse, ApiError, void>({
    ...options,
    mutationFn: destroyPlanTrial,
  });
};
